module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "hgroup"
  }, [_c('h3'), _vm._v(" "), _c('h1', [_vm._v("Copyright")])])]), _vm._v(" "), _c('h1', {
    staticClass: "head"
  }, [_vm._v("\n\tCopyright")]), _vm._v(" "), _c('div', {
    staticClass: "halftitle"
  }, [_c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tDiversion Books")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tA Division of Diversion Publishing Corp.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\t443 Park Avenue South, Suite 1004")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tNew York, NY 10016")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    attrs: {
      "href": "http://www.diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tCopyright © 1989 by Anita Mills")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tAll rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")])]), _vm._v(" "), _c('div', {
    staticClass: "copy_block"
  }, [_c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFor more information, email "), _c('a', {
    attrs: {
      "href": "http://info@diversionbooks.com",
      "target": "_blank"
    }
  }, [_vm._v("info@diversionbooks.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tFirst Diversion Books edition May 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_vm._v("\n\t\t\tISBN: 9781626810464")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('p'), _vm._v(" "), _c('p', {
    staticClass: "first_small_top"
  }), _vm._v(" "), _c('p', {
    staticClass: "first_small_top"
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('em', [_c('strong', [_vm._v("Also by Anita Mills")])])]), _vm._v(" "), _c('p', {
    staticClass: "first_small_top",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "first",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('strong', [_vm._v("The Fire Series")]), _c('br'), _vm._v(" "), _c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lady of Fire"), _c('br'), _vm._v("\n\tFire and Steel"), _c('br'), _vm._v("\n\tHearts of Fire"), _c('br'), _vm._v("\n\tThe Fire and the Fury"), _c('br'), _vm._v("\n\tWinter Roses")])]), _vm._v(" "), _c('p', {
    staticClass: "first_small_top",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Duel of Hearts")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Devil’s Match")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scandal Bound")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Follow the Heart")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Secret Nights")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bittersweet")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Rogue’s Return")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Autumn Rain")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Miss Gordon’s Mistake")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Newmarket Match")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chap153474",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dangerous")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "first_small_top",
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }), _vm._v(" "), _c('p'), _vm._v(" "), _c('p')])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac198bb0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chap139422.vue
// module id = 63
// module chunks = 0